import React, { useRef, useState } from 'react'
import { emptyForm, Form, IAssignmentForm } from './Form';
import Table from './Table';
import { Toast } from 'primereact/toast';


export interface IModal {
    singleData: IAssignmentForm,
    open: boolean
}
export const AssignmentMast = () => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);


    const hideDialog = () => {
        setModal({ singleData: emptyForm, open: false });
    };

    return (
        <div>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </div>
    )
}

